import { CtaSection } from '@/components/common/CtaSection'
import { HomeHero } from '@/components/home/hero'
// import { IdeologySection } from '@/components/home/ideology'
import { ProblemsSection } from '@/components/home/problems'
import { ProcessSection } from '@/components/home/process'
import { ProductsSection } from '@/components/home/products'
import { ServicesSection } from '@/components/home/services'
import TestimonialsSection from '@/components/home/testimoniols'
import StudiesSection from '@/components/home/studies'
import WhyCodefied from '@/components/home/whycodefied'

export function HomePage() {
  return (
    <>
      <HomeHero />
      <ProblemsSection />
      {/* <IdeologySection /> */}
      <ServicesSection />
      <ProductsSection />
      <ProcessSection />
      <WhyCodefied />
      <TestimonialsSection />
      <StudiesSection />
      <CtaSection isHomePage />
    </>
  )
}
